module.exports = __webpack_public_path__ + "c783fd3b648d2422e5796ccc703c8b90.pdf";